import { useState } from "react";
import axios from "axios";
import ErrorBanner from "../components/ErrorBanner";

function NewWell({ token, onBack, onSaved }) {
  const [form, setForm] = useState({
    well_name: "",
    basin: "",
    location: "",
    latitude: "",
    longitude: "",
    status: "",
    current_phase: "",
    spud_date: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/wells`,
        {
          ...form,
          latitude: Number(form.latitude),
          longitude: Number(form.longitude),
        },
        {
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        },
      );
      onSaved();
    } catch (err) {
      setError(err.response?.data?.error || "Failed to create well");
    } finally {
      setLoading(false);
    }
  }

  const cyan = "#00f5ff";
  const inputStyle = {
    width: "100%",
    backgroundColor: "rgba(0,245,255,0.05)",
    border: "1px solid rgba(0,245,255,0.2)",
    borderRadius: "6px",
    padding: "10px 14px",
    color: "white",
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box",
  };
  const labelStyle = {
    color: cyan,
    fontSize: "10px",
    letterSpacing: "2px",
    textTransform: "uppercase",
    display: "block",
    marginBottom: "6px",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#020817",
        fontFamily: "'Segoe UI', sans-serif",
      }}
    >
      <nav
        style={{
          backgroundColor: "rgba(0,0,0,0.6)",
          borderBottom: "1px solid rgba(0,245,255,0.15)",
          padding: "14px 28px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: "22px",
            fontWeight: "900",
            letterSpacing: "4px",
            background: "linear-gradient(135deg, #00f5ff, #0080ff)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          RIGIQ
        </div>
        <button
          onClick={onBack}
          style={{
            color: "rgba(0,245,255,0.5)",
            background: "none",
            border: "1px solid rgba(0,245,255,0.15)",
            cursor: "pointer",
            fontSize: "11px",
            padding: "5px 12px",
            borderRadius: "4px",
            letterSpacing: "1px",
          }}
        >
          ← BACK
        </button>
      </nav>

      <main style={{ padding: "28px", maxWidth: "640px" }}>
        <h2
          style={{
            fontSize: "22px",
            fontWeight: "800",
            letterSpacing: "3px",
            color: "white",
            marginBottom: "4px",
          }}
        >
          NEW WELL
        </h2>
        <p
          style={{
            color: "rgba(0,245,255,0.4)",
            fontSize: "11px",
            letterSpacing: "3px",
            marginBottom: "28px",
          }}
        >
          REGISTER WELL TO OPERATIONS
        </p>

        <form
          onSubmit={handleSubmit}
          style={{
            backgroundColor: "rgba(0,245,255,0.03)",
            border: "1px solid rgba(0,245,255,0.15)",
            borderRadius: "12px",
            padding: "28px",
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "16px",
            }}
          >
            <div style={{ gridColumn: "1 / -1" }}>
              <label style={labelStyle}>Well Name</label>
              <input
                name="well_name"
                value={form.well_name}
                onChange={handleChange}
                required
                style={inputStyle}
                placeholder="e.g. Bakken Pad 14A Well 4"
              />
            </div>
            <div>
              <label style={labelStyle}>Basin</label>
              <input
                name="basin"
                value={form.basin}
                onChange={handleChange}
                style={inputStyle}
                placeholder="e.g. Williston"
              />
            </div>
            <div>
              <label style={labelStyle}>Location</label>
              <input
                name="location"
                value={form.location}
                onChange={handleChange}
                style={inputStyle}
                placeholder="e.g. Watford City, ND"
              />
            </div>
            <div>
              <label style={labelStyle}>Latitude</label>
              <input
                name="latitude"
                value={form.latitude}
                onChange={handleChange}
                style={inputStyle}
                placeholder="e.g. 47.8011"
              />
            </div>
            <div>
              <label style={labelStyle}>Longitude</label>
              <input
                name="longitude"
                value={form.longitude}
                onChange={handleChange}
                style={inputStyle}
                placeholder="e.g. -103.3379"
              />
            </div>
            <div>
              <label style={labelStyle}>Status</label>
              <select
                name="status"
                value={form.status}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="active">Active</option>
                <option value="standby">Standby</option>
                <option value="completed">Completed</option>
                <option value="shut-in">Shut-In</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Current Phase</label>
              <select
                name="current_phase"
                value={form.current_phase}
                onChange={handleChange}
                style={inputStyle}
              >
                <option value="drilling">Drilling</option>
                <option value="completion">Completion</option>
                <option value="workover">Workover</option>
                <option value="production">Production</option>
              </select>
            </div>
            <div style={{ gridColumn: "1 / -1" }}>
              <label style={labelStyle}>Spud Date</label>
              <input
                type="date"
                name="spud_date"
                value={form.spud_date}
                onChange={handleChange}
                style={inputStyle}
              />
            </div>
          </div>

          {error && (
            <div style={{ margin: "16px 0" }}>
              <ErrorBanner message={error} />
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              marginTop: "24px",
              width: "100%",
              background: "linear-gradient(135deg, #00f5ff, #0080ff)",
              color: "#020817",
              fontWeight: "700",
              fontSize: "12px",
              letterSpacing: "3px",
              padding: "12px",
              borderRadius: "6px",
              border: "none",
              cursor: "pointer",
              boxShadow: "0 0 20px rgba(0,245,255,0.3)",
            }}
          >
            {loading ? "REGISTERING..." : "REGISTER WELL"}
          </button>
        </form>
      </main>
    </div>
  );
}

export default NewWell;
